import { render } from "./OTCPage.vue?vue&type=template&id=5d44c209&scoped=true"
import script from "./OTCPage.vue?vue&type=script&lang=js"
export * from "./OTCPage.vue?vue&type=script&lang=js"

import "./OTCPage.vue?vue&type=style&index=0&id=5d44c209&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d44c209"]])

export default __exports__